import { render } from "./Header.vue?vue&type=template&id=146e2983&scoped=true"
import script from "./Header.vue?vue&type=script&setup=true&lang=js"
export * from "./Header.vue?vue&type=script&setup=true&lang=js"

import "./Header.vue?vue&type=style&index=0&id=146e2983&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-146e2983"],['__file',"src/components/layouts/Header.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "146e2983"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('146e2983', __exports__)) {
    api.reload('146e2983', __exports__)
  }
  
  module.hot.accept("./Header.vue?vue&type=template&id=146e2983&scoped=true", () => {
    api.rerender('146e2983', render)
  })

}


export default __exports__